var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575 3186 c-66 -29 -105 -107 -91 -179 15 -75 213 -334 396 -517 213 -214 426 -368 680 -494 802 -397 1727 -288 2458 291 193 153 420 400 561 612 52 78 56 88 56 142 0 96 -58 154 -155 154 -75 0 -98 -17 -170 -123 -288 -424 -704 -749 -1139 -892 -874 -287 -1801 65 -2366 899 -27 41 -62 83 -77 94 -33 25 -113 32 -153 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895 2066 c-16 -8 -114 -99 -217 -202 -201 -203 -209 -217 -193 -301 9 -49 69 -109 118 -118 85 -16 97 -9 309 203 167 167 198 203 203 235 25 132 -101 236 -220 183z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4095 2066 c-67 -29 -105 -105 -90 -183 5 -32 36 -68 203 -235 212 -212 224 -219 309 -203 49 9 109 69 118 118 16 84 8 98 -193 301 -103 103 -201 194 -219 202 -40 17 -89 17 -128 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615 1666 c-16 -7 -40 -24 -52 -37 -12 -13 -63 -127 -113 -254 -80 -199 -91 -236 -87 -274 5 -47 27 -83 71 -115 20 -16 42 -21 86 -21 50 0 63 4 96 31 35 28 49 56 131 260 81 200 93 235 89 277 -6 80 -62 137 -143 144 -28 2 -61 -2 -78 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3375 1666 c-56 -25 -95 -85 -95 -147 0 -38 176 -477 203 -508 66 -72 182 -66 242 13 52 68 48 93 -55 351 -50 127 -101 241 -113 254 -44 48 -122 64 -182 37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2495 1506 c-41 -18 -83 -69 -90 -109 -3 -18 -5 -136 -3 -264 3 -216 4 -233 24 -259 39 -53 71 -69 134 -69 63 0 95 16 134 69 20 26 21 40 21 286 0 246 -1 260 -21 286 -11 15 -32 37 -46 47 -33 25 -113 32 -153 13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibility-off.8380a66bf2dd3f5bfccedf9914739493.svg";
export { ForwardRef as ReactComponent };